import env from '@common/constants/env';
import { i18n } from 'next-i18next';
const aliasMap = {
    cn: 'zh'
};
/**
 * 获取当前语言值
 */
export function getLocaleValue(value) {
    const lng = (i18n === null || i18n === void 0 ? void 0 : i18n.language) || env.DEFAULT_LOCAL;
    const alias = aliasMap[lng];
    return value ? (alias ? value[alias] || value[lng] : value[lng]) : '';
}
